import React, { useEffect, useRef } from "react";

function WebComponentAdapter<P extends { [K: `on${string}`]: (...args: any[]) => void; [K: string]: unknown }>(
	webComponentName: string,
): React.FC<P & { children?: React.ReactNode }> {
	return function Wrapped(props) {
		const { children, className, ...rest } = props;
		const events: [string, () => void][] = [];
		const otherProps = {};

		for (const [key, value] of Object.entries(rest)) {
			if (key.startsWith("on") && typeof value === "function") {
				const eventName = key
					.substring(2)
					.replace(/([a-z])([A-Z])/g, "$1-$2")
					.toLowerCase();
				events.push([eventName, value]);
			} else {
				otherProps[key] = value;
			}
		}

		const ref = useRef<HTMLElement>(null);
		const classProp = className ? { class: className } : {};
		const element = React.createElement(webComponentName, { ...classProp, ...otherProps, ref }, children);

		useEffect(() => {
			const node = ref.current;
			for (const [eventName, callback] of events) {
				node?.addEventListener(eventName, callback);
			}
			return () => {
				for (const [eventName, callback] of events) {
					node?.removeEventListener(eventName, callback);
				}
			};
		});

		return element;
	};
}

export default WebComponentAdapter;
